<script>
import ResumeTimeline from "@/components/ResumeTimeline.vue";

export default {
  components: {ResumeTimeline},
}
</script>

<template>
  <div id="resume">
    <h1 class="text-center normal-heading">{{ $t('resume.experience') }}</h1>
    <ResumeTimeline :entries="$tm('resume.experienceTimepoints')"/>

    <h1 class="text-center normal-heading">{{ $t('resume.education') }}</h1>
    <ResumeTimeline :entries="$tm('resume.educationTimepoints')"/>

    <h1 class="text-center normal-heading">{{ $t('resume.skills') }}</h1>
    <div class="skills">
      <section v-for="group in ['hardSkill', 'softSkill']" :key="group" class="skill-panel">
        <h2 class="skill-panel-title">{{ $t(`resume.${group}s`) }}</h2>

        <ul class="skill-list">
          <li v-for="item in $tm(`resume.${group}Items`)" :key="item.name" class="skill">
            <span class="skill-icon"><i :class="item.icon"></i></span>
            <div class="skill-info">
              <span class="skill-name">{{ item.name }}</span>
              <span class="skill-eval">{{ item.eval }}</span>
            </div>
            <ul v-if="item.tags" class="skill-tags">
              <li v-for="tag in item.tags" :key="tag">{{ tag }}</li>
            </ul>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<style scoped>
.skills {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 460px), 1fr));
  align-items: start;
  gap: 2rem;
  max-width: 1100px;
  margin: 0 auto 4rem;
  padding: 0 1rem;
}

.skill-panel {
  padding: 1.5rem 1.75rem 0.75rem;
  border-radius: 1rem;
  background: #fff;
  border: 1px solid rgba(17, 17, 17, 0.08);
  box-shadow: 0 2px 10px rgba(17, 17, 17, 0.06);
}

.skill-panel-title {
  font-size: 1.35rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 3px solid var(--bs-primary);
}

.skill-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.skill {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 0;
  border-bottom: 1px solid rgba(17, 17, 17, 0.07);
}

.skill:last-child {
  border-bottom: none;
}

.skill-icon {
  flex: none;
  display: grid;
  place-items: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 0.75rem;
  background: rgba(13, 110, 253, 0.1);
  transition: background 0.3s ease;
}

.skill-icon i {
  color: var(--bs-primary);
  font-size: 1.15rem;
  transition: color 0.3s ease;
}

.skill:hover .skill-icon {
  background: var(--bs-primary);
}

.skill:hover .skill-icon i {
  color: #fff;
}

.skill-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.skill-name {
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.3;
}

.skill-eval {
  font-size: 0.9rem;
  color: #666;
}

.skill-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.35rem;
  max-width: 45%;
  list-style: none;
  padding: 0;
  margin: 0;
}

.skill-tags li {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  color: #fff;
  background: var(--bs-primary);
}

/* the global stylesheet enlarges every h2 on small screens */
@media only screen and (max-width: 991px) {
  .skill-panel-title {
    font-size: 1.35rem;
  }
}

/* on phones the tags move below the name */
@media only screen and (max-width: 575px) {
  .skill-panel {
    padding: 1.25rem 1.1rem 0.5rem;
  }

  .skill {
    flex-wrap: wrap;
  }

  .skill-tags {
    max-width: none;
    justify-content: flex-start;
    flex-basis: 100%;
    padding-left: 3.75rem;
  }
}
</style>
